import { useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { textFormatter } from 'src/utils';
import {
  assignConfirmModalId,
  assignModalId,
  assignSubMenuModalId
} from 'src/store/common/common.slice';
import { useGetIdentity } from 'src/hooks';

import InviteUser from './inviteUser/InviteUser';
import './header.scss';

import { hTractionLogoWithText } from 'src/assets/images';

import { Button, Dropdown, ProfilePicture, SubMenuModal, TDropdown, Typography } from 'src/components/common';
import { SingleChevronIcon } from 'src/components/common/common.icons';

const signOutModalId = 'sign-up-modal-id';

const Header = () => {
  const { profile } = useAppSelector((store) => store.profile);
  const { companyProfilePic, myCompany } = useAppSelector((store) => store.company);
  const { dropdownId } = useAppSelector((store) => store.common);

  // Hooks
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthorized } = useAppSelector((store) => store.auth);
  const { getIdentities } = useGetIdentity();

  const openSignOutModal = () => {
    dispatch(assignConfirmModalId(signOutModalId));
  };

  const { loggedInUserType } = getIdentities();
  const headerProfilePic = loggedInUserType === 'User' ? companyProfilePic : profile?.profilePic;
  const headerName = loggedInUserType === 'User' ? profile?.name : myCompany.name;
  const includedPath = ['/demo-day', '/demo-day-register', '/demo-day-register/payment', '/demo-day-register/document-submission', '/demo-day-register/slot-booking', '/demo-day-register/success', '/demo-day-detail', '/not-found'];

  const headerDropdownItems = useMemo(() => {
    return [
      { label: 'Edit Profile', onClick: () => navigate('/investor') },
      { label: 'Logout', onClick: openSignOutModal }
    ];
  }, [navigate]);

  const headerOptions: TDropdown = {
    id: 'header-dropdown',
    size: 'large',
    alignment: 'left',
    items: headerDropdownItems
  };
  const openDropdown = () => {
    if (dropdownId) {
      dispatch(assignSubMenuModalId(''));
    } else {
      dispatch(assignSubMenuModalId(headerOptions.id));
    }
  };

  return (
    <div className="demo-day-header-component" >
      <div className="demo-day-header-component__wrapper">
        <img
          src={hTractionLogoWithText}
          alt="htraction logo"
          className="demo-day-header-component__htraction-logo"
        />

        {!isAuthorized && <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <div className="demo-day-header-component__search" style={{ opacity: '0', width: '85%' }}></div>
          <Button
            variant="secondary"
            size="extraSmall"
            style={{ width: 'auto' }}
            className="demo-day-header-component__right__invite-user"
            onClick={() => navigate('/login')}
          >
            Login / Signup
          </Button>
        </div>}
        {<div className="demo-day-header-component__right">

          <div className="demo-day-header-component__right__menu" >
            {isAuthorized && <>
              <div className="demo-day-header-component__right__menu__profile-picture" onClick={(e) => {
                e.stopPropagation();
                openDropdown();
              }}>
                <ProfilePicture
                  url={headerProfilePic || ''}
                  fallback={textFormatter({ value: headerName[0] || '' })}
                  userType={loggedInUserType}
                />
              </div>
              <Typography as="p" variant="body-2" fontWeight="medium" className='cursor_pointer' onClick={(e) => {
                e.stopPropagation();
                openDropdown();
              }}>
              </Typography>
              <div
                className="demo-day-header-component__right__menu__arrow"
                onClick={(e) => {
                  e.stopPropagation();
                  openDropdown();
                }}
              >
                <SingleChevronIcon direction="down" />
              </div>
            </>}

            <SubMenuModal>
              <Dropdown {...headerOptions} />
            </SubMenuModal>
          </div>
        </div>}

        {/* {openInviteUserModal && isAuthorized && (
        <InviteUser isModalOpen={openInviteUserModal} closeModal={handleCloseInviteUserModal} />
      )} */}

      </div>
    </div >
  );
};

export default Header;
